import { render, staticRenderFns } from "./commission-details.vue?vue&type=template&id=01c021ee&scoped=true"
import script from "./commission-details.vue?vue&type=script&lang=js"
export * from "./commission-details.vue?vue&type=script&lang=js"
import style0 from "./commission-details.vue?vue&type=style&index=0&id=01c021ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c021ee",
  null
  
)

export default component.exports